export default "__VITE_ASSET__bf21616e__"